import { PermissionEnum } from "@altertec_gparn/lib";
import { UserDto } from "@/core/features/users/user.dto";

export function canAccessPlanningBoard(me: UserDto | null | undefined): boolean {
  if (!me?.role?.permissions?.includes(PermissionEnum.SCHEDULER_PLANNING_BOARD)) {
    return false;
  }

  if (me.role.permissions.includes(PermissionEnum.SCHEDULER_PLANNING_BOARD_ALL_BUSINESS_UNITS)) {
    return true;
  }

  return Boolean(me.operativeUnit?.businessUnitId);
}

export function canSelectAllPlanningBoardBusinessUnits(me: UserDto | null | undefined): boolean {
  if (!canAccessPlanningBoard(me)) {
    return false;
  }

  return Boolean(me?.role?.permissions?.includes(PermissionEnum.SCHEDULER_PLANNING_BOARD_ALL_BUSINESS_UNITS));
}
